import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import MaterialTable from 'material-table';
import { Container } from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';

import api from '../../../../services/api.js';

import Add from './Components/Add.js'
import Edit from './Components/Edit.js'

export default function MyTable(props) {
    const tableRef = useRef();
    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [users, setUsers] = useState([]);

    const state = {
        columns: [
            {
                title: "Opções",
                field: "opcoes",
                render: (rowData) => {
                    return (
                        <Edit setData={props.setData} setOpen={props.setOpen} data={rowData} />
                    )
                }
            },
            { title: "Nome", field: "nome" },
            { title: "Função", field: "funcao" },
            { title: "Cargo", field: "cargo" }, //banco
            { title: "E-mail", field: "email" },
            { title: "Celular", field: "celular" },
            // {
            //     title: "Usina de Atuação",
            //     render: (rowData) => {
            //         return (
            //             <>
            //                 {rowData.usina_atuacao.map(txt => <p>{txt}</p>)}
            //             </>
            //         )
            //     }
            // },
        ],
    };

    useEffect(() => {
        async function fetchData() {
            api.get(`/users`)
                .then((res) => {
                    let users = []
                    for (let user of res.data) {
                        if (user["real"] === true) {
                            let usina_atuacao = []
                            for (let usina of user.usinas) {
                                usina_atuacao.push(usina.nome)
                            }
                            // identifica se o usuário esta em exercício
                            let em_exercicio = "Não"
                            if (user._id === user.funcao.exercicio) {
                                em_exercicio = "Sim"
                            }
                            users.push({
                                _id: user._id,
                                nome: user.nome,
                                admin: user.admin,
                                cargo: user.cargo,
                                email: user.email,
                                usinas: user.usinas,
                                status: user.status,
                                celular: user.celular,
                                telefone: user.telefone,
                                funcao: user.funcao.funcao,
                                em_exercicio: em_exercicio,
                                usina_atuacao: usina_atuacao,
                                criado_por: user.criado_por,
                                criado_em: user.criado_em,
                                editado_por: user.editado_por,
                                editado_em: user.editado_em,
                            })
                        }
                    }
                    setUsers(users)
                })
                .catch((error) => {
                    console.log(error);
                    snack.current("Falha ao buscar usuários", { variant: 'error' })
                });
        }
        fetchData();
    }, [props.reload]);

    return (
        <Container maxWidth={false} spacing={2}>
            <MaterialTable
                tableRef={tableRef}
                title="Usuários"
                columns={state.columns}
                data={users}
                options={{
                    search: true,
                    pageSize: 10,
                    exportButton: false,
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [1, 5, 10, 20, users.length],
                    padding: "dense",
                    headerStyle: {
                        textAlign: "center",
                        color: "#b31b1b",
                    },
                    cellStyle: {
                        textAlign: "center",
                    },
                }}

                localization={{
                    body: {
                        emptyDataSourceMessage: "",
                        addTooltip: "adicionar novo",
                        deleteTooltip: "excluir",
                        editRow: { deleteText: "Deseja excluir?" },
                    },

                    header: {
                        actions: "Opções",
                    },

                    toolbar: {
                        searchTooltip: "Pesquisar",
                        searchPlaceholder: "Pesquisar",
                        exportTitle: "exportar",
                        nRowsSelected: "{0} Usuários(s) selecionados",
                    },
                    pagination: {
                        labelRowsSelect: "",
                        labelDisplayedRows: "{count} de {from}-{to}",
                        firstTooltip: "Primeira página",
                        previousTooltip: "Página anterior",
                        nextTooltip: "Próxima página",
                        lastTooltip: "Última página",
                    },
                }}
                components={{
                    Actions: () => {
                        return (
                            <Add setData={props.setData} setOpen={props.setOpen} />
                        );
                    }
                }}
            />
        </Container >
    );
}

MyTable.propTypes = {
    reload: PropTypes.bool,
    setData: PropTypes.func,
    setOpen: PropTypes.func,
    setReload: PropTypes.func,
    setAffiliates: PropTypes.func,
};
